import { useState } from "react";
import { useModal } from "../contexts";
import Modal from "./Modal";
import SmallTextInputField from "./SmallTextInputField";
import { useTranslation } from "react-i18next";

interface Props {
  onAddLink: (text: string, url: string) => void;
  onClose?: () => void;
}

function WorkflowModalLink(props: Props) {
  const { onAddLink, onClose } = props;
  const { t } = useTranslation();

  const { closeModal } = useModal();

  const [hasChanged, setHasChanged] = useState<boolean>(false);
  const [displayText, setDisplayText] = useState<string>("");
  const [url, setUrl] = useState<string>("");

  function handleChangeDisplayText(value: string) {
    setHasChanged(true);
    setDisplayText(value);
  }

  function handleChangeUrl(value: string) {
    setHasChanged(true);
    setUrl(value);
  }

  function handleInsertLink() {
    let externalUrl;
    if (url.startsWith("http://") || url.startsWith("https://"))
      externalUrl = url;
    else
      externalUrl = "http://" + url;

    onAddLink(displayText, externalUrl);
    handleOnClose();
  }

  function handleOnClose() {
    if (onClose)
      onClose();

    closeModal();
  }

  return (
    <Modal
      title={t("Insert Link")}
      secondaryButtonProps={{ text: t("Cancel"), onClick: handleOnClose }}
      primaryButtonProps={{ disabled: !hasChanged, onClick: handleInsertLink, text: t("Insert") }}
    >
      <SmallTextInputField label={t("Display Text")} value={displayText} onChange={handleChangeDisplayText} />
      <SmallTextInputField label="URL" value={url} onChange={handleChangeUrl} />
    </ Modal>
  )
}

export default WorkflowModalLink;
